

















































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import getUrlParam from "@/common/utils/getUrlParam";
import { replaceString } from "@/common/utils/dealWithString";
import getActivityDeadline from "@/common/utils/getActivityDeadline";

@Component
export default class SolitaireTitleSection extends Vue {
  @Getter("title") getterTitle!: string;
  @Getter("deadline") deadline!: number;
  @Getter("startTime") startTime!: number;
  @Getter("titleSection") titleSection!: object;
  @Getter("showJoinFooter") showJoinFooter!: boolean;

  type: string = getUrlParam("type") as string;

  get title(): string {
    return replaceString(this.getterTitle);
  }

  dealwithTime(activityDeadline: any) {
    const nowTimestamp: number = new Date().valueOf();
    return {
      nowTimestamp,
      activityDeadline
    };
  }
  get isActivityFinish(): boolean {
    const { nowTimestamp, activityDeadline } = this.dealwithTime(this.deadline);
    return nowTimestamp >= activityDeadline;
  }

  // 剩余天数
  get deadlineDay(): number {
    return getActivityDeadline(this.deadline).deadlineDay;
  }
  // 剩余小时
  get deadlineHour(): string | number {
    return getActivityDeadline(this.deadline).deadlineHour;
  }
  // 剩余分钟
  get deadlineMinute(): string | number {
    return getActivityDeadline(this.deadline).deadlineMinute;
  }

  get isActivityStart(): boolean {
    return new Date().valueOf() < this.startTime;
  }

  // 剩余天数
  get startTimeDay(): number {
    return getActivityDeadline(this.startTime).deadlineDay;
  }
  // 剩余小时
  get startTimeHour(): string | number {
    return getActivityDeadline(this.startTime).deadlineHour;
  }
  // 剩余分钟
  get startTimeMinute(): string | number {
    return getActivityDeadline(this.startTime).deadlineMinute;
  }
}
